module.exports = __webpack_public_path__ + "img/PDM-80.f4b2a0ea.webp";